module.exports = "{{t \"updateProfile\"}}"